/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {TrackingFavoriteNameValidationError} from './favoriteUtils';

export enum FavoriteDialogType {
  Create = 'create',
  Edit = 'edit',
  Rename = 'rename',
  SaveAsNew = 'saveAsNew'
}

export interface FavoriteDialogState {
  error?: TrackingFavoriteNameValidationError | null;
  name?: string;
  type: FavoriteDialogType;
}

export interface FavoriteDialogLabels {
  cancel: string;
  description: string;
  inputLabel: string;
  placeholder: string;
  primaryLabel: string;
  title: string;
}
